import { IconName } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useDocumentoComercialPendienteFirmar } from "api/DocumentoComercial.hook"
import { useValidacionesPendientesUsuario } from "api/Usuario.hook"
import { TFunction } from "i18next"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import * as ROUTES from "routes/RoutePaths"
import { KEYS } from "../MdfDialog/constants"

export const SIDE_BAR_MENU = ({
  show = false,
  expandedWidth = true,
  showSubMenu = false,
  action,
  pathname,
  modals,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any, sonarjs/cognitive-complexity
any): $TSMigrationFixMe => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(show)
  const [openSubMenu, setOpenSubMenu] = useState({
    documents: false,
    accounting: false,
    inventory: false,
    treasury: false,
    import: false,
  })

  const closeAllMenus = () => {
    setOpenSubMenu({
      documents: false,
      accounting: false,
      inventory: false,
      treasury: false,
      import: false,
    })
  }

  useEffect(() => {
    closeAllMenus()
  }, [showSubMenu])

  const sectionClassName = `tw-select-none tw-mx-auto tw-w-20 ${
    open ? "tw-visible" : "tw-hidden"
  } ${expandedWidth ? "tw-w-60" : ""} tw-pb-4`
  const sectionItemClassName = `tw-static tw-flex tw-cursor-pointer tw-w-20 tw-px-2  tw-items-center hover:tw-text-secondary ${
    expandedWidth
      ? "tw-flex-row tw-w-[236px] tw-h-[40px] tw-mt-4"
      : "tw-flex-col tw-mt-10"
  }`
  const titleClassName = `tw-flex-grow sm:tw-mr-0 ${
    expandedWidth
      ? "tw-uppercase tw-text-sm tw-font-medium tw-text-left"
      : "tw-mt-2 tw-text-xs tw-font-normal"
  }`
  const titleLeftIconClassName = `tw-h-6 tw-w-6 tw-flex-none ${
    expandedWidth ? "tw-mr-3" : ""
  }`
  const titleRightIconClassName = `tw-h-5 tw-w-[15px] ${
    expandedWidth ? "tw-block" : "tw-hidden"
  }`
  const submenuClassName = `tw-text-text md:tw-m-0 md:tw-block ${
    !expandedWidth
      ? "md:tw-min-w-[240px] !tw-inline-block md:!tw--mt-80 md:tw-ml-16 !tw-absolute !tw-shadow-prascard !tw-rounded-lg md:tw-shadow-md tw-bg-white"
      : "md:tw-static"
  } tw-z-40 open`
  const submenuClosedClassName = `tw-min-w-[236px] tw-cursor-pointer tw-text-white tw-overflow-hidden tw-max-h-0 
      sm:tw-text-text hover:tw-text-secondary ${
        expandedWidth
          ? "sm:!tw-text-white  !tw-rounded"
          : "lg:!tw-bg-white lg:!tw-text-text !tw-rounded-lg"
      } closed`
  const submenuTitleClassName = `tw-w-0 tw-overflow-hidden tw-max-h-0 sm:tw-text-black !tw-bg-white ${
    expandedWidth ? "tw-hidden" : "!tw-w-auto !tw-rounded-t-lg"
  }`

  const submenuSvg = (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 16 20'
      fill='none'
      className='tw-my-0.5 tw-mx-1'
    >
      <rect
        width='12'
        height='16'
        rx='1'
        fill='#D90368'
      />
      <rect
        opacity='0.75'
        x='4'
        y='4'
        width='12'
        height='16'
        rx='1'
        fill='#00D8AC'
      />
    </svg>
  )
  const leftIconNotification = (
    expandedWidth: boolean,
    icon: IconName,
    hasNotification = false
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): $TSMigrationFixMe => {
    if (expandedWidth) {
      return (
        <div className='tw-flex tw-justify-center tw-items-center tw-h-full tw-p-1 tw-text-center tw-w-9'>
          <div
            className={`tw-rounded-full tw-h-2 tw-w-2 ${
              hasNotification ? "tw-bg-white" : ""
            }`}
          />
        </div>
      )
    }
    if (!expandedWidth) {
      return (
        <div className='tw-flex tw-justify-center tw-items-center tw-h-6 tw-p-1 tw-text-center tw-w-6'>
          <FontAwesomeIcon
            className='tw-w-[20px] tw-h-[20px]'
            icon={["fal", icon]}
          />
        </div>
      )
    }
  }

  const rightIconNotification = (
    expandedWidth: boolean,
    hasNotification = false
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): $TSMigrationFixMe => {
    if (!expandedWidth) {
      return (
        <div className='tw-flex tw-justify-center tw-items-center tw-h-full tw-pl-2 tw-pr-5 tw-text-center tw-w-9'>
          <div
            className={`tw-rounded-full tw-h-2 tw-w-2 ${
              hasNotification ? "tw-bg-primary" : ""
            }`}
          />
        </div>
      )
    }
  }

  const { documentoComercialData } = useDocumentoComercialPendienteFirmar()
  const { usuarioValidacionesPendienteResponse } =
    useValidacionesPendientesUsuario()

  const isNotificacionesValidaciones =
    (documentoComercialData?.total ?? 0) > 0 ||
    usuarioValidacionesPendienteResponse?.hayCesiones ||
    usuarioValidacionesPendienteResponse?.hayFacturas ||
    usuarioValidacionesPendienteResponse?.hayPagares

  useEffect(() => {
    setOpen(show)
  }, [show])

  return [
    {
      section: {
        key: "solcitarFinanciacion",
        title: "",
        className: `${sectionClassName} tw-mt-8 lg:tw-hidden`,
        items: [
          {
            key: "compartirHerramienta",
            title: (
              <div className='tw-flex tw-w-full tw-h-12 tw-rounded-md tw-bg-secondary tw-text-white tw-justify-center tw-items-center tw-mb-8'>
                {t("nav.soliciteFinancicion")}
              </div>
            ),
            className: ``,
            action: () => {
              modals.setCollapsed(false)
              !expandedWidth && closeAllMenus()
              action(
                ROUTES.FACTURAS,
                {
                  mode: true,
                },
                false
              )
            },
          },
        ],
      },
    },
    {
      section: {
        key: "withoutSectionTitle",
        title: "",
        className: sectionClassName,
        items: [
          {
            key: "crear",
            title: (
              <div className={`${titleClassName} !tw-text-lg`}>
                {expandedWidth ? "CREAR" : ""}
              </div>
            ),
            className: `${sectionItemClassName} tw-text-white ${
              expandedWidth ? "xl:tw-flex-row xl:tw-uppercase" : ""
            } !tw-mb-8`,
            classNameSubMenu: submenuClassName,
            leftIcon: (
              <FontAwesomeIcon
                icon={["fal", "circle-plus"]}
                className={
                  expandedWidth ? "tw-mr-3 tw-h-8 tw-w-8" : "tw-h-12 tw-w-12"
                }
              />
            ),
            action: () => {
              modals.setCollapsed(false)
              !expandedWidth && closeAllMenus()
              modals.setShowMenuNuevosDocumentos(true)
            },
          },
          {
            key: "validations",
            title: (
              <div className={titleClassName}>{t("nav.validationsLabel")}</div>
            ),
            className: `${sectionItemClassName} ${
              pathname?.includes(ROUTES.VALIDACIONES_DOCUMENTOS)
                ? "tw-text-secondary"
                : "tw-text-white"
            }`,
            classNameSubMenu: submenuClassName,
            leftIcon: (
              <FontAwesomeIcon
                className={titleLeftIconClassName}
                icon={["fal", "ballot-check"]}
              />
            ),
            action: () => {
              action(ROUTES.VALIDACIONES_DOCUMENTOS, {}, true)
            },
            pendding: isNotificacionesValidaciones,
          },
          {
            key: "documents",
            title: (
              <div className={titleClassName}>{t("nav.documentLabel")}</div>
            ),
            className: `${sectionItemClassName} ${
              pathname?.includes(ROUTES.DOCUMENTOS)
                ? "tw-text-secondary"
                : "tw-text-white"
            }`,
            classNameSubMenu: submenuClassName,
            leftIcon: (
              <FontAwesomeIcon
                className={titleLeftIconClassName}
                icon={["fal", "inboxes"]}
              />
            ),
            rightIcon: (
              <FontAwesomeIcon
                className={titleRightIconClassName}
                icon={[
                  "fal",
                  `${openSubMenu.documents ? "angle-down" : "angle-right"}`,
                ]}
              />
            ),

            open: openSubMenu.documents,
            subMenu: {
              title: (
                <div
                  className={`${submenuTitleClassName} ${
                    openSubMenu.documents ? "tw-max-h-32 " : ""
                  } `}
                >
                  <div
                    className={`tw-hidden sm:!tw-flex sm:tw-flex-row tw-justify-start tw-text ${
                      !expandedWidth &&
                      "sm:!tw-block tw-pt-6 tw-pb-4 sm:tw-px-4 sm:tw-rounded"
                    }`}
                  >
                    {submenuSvg}
                    <span className='tw-px-3 tw-align-middle tw-text-lg tw-font-bold tw-h-[24px] tw-my-0.5'>
                      {t("nav.documentLabel")}
                    </span>
                  </div>
                </div>
              ),
              subMenuClassNameClosed: `${submenuClosedClassName}`,
              subMenuClassNameOpen: `tw-max-h-32 tw-transform`,
              items: [
                {
                  key: "presupuestos",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.PRESUPUESTOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 tw-mt-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20 "
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.quotationLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.PRESUPUESTOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "file",
                    pathname?.includes(ROUTES.PRESUPUESTOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.PRESUPUESTOS)
                  },
                },
                {
                  key: "pedidos",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.PEDIDOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.orderLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.PEDIDOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "file-lines",
                    pathname?.includes(ROUTES.PEDIDOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.PEDIDOS)
                  },
                },
                {
                  key: "albaranes",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.ALBARANES)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.deliveryLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.ALBARANES)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "file-contract",
                    pathname?.includes(ROUTES.ALBARANES)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.ALBARANES)
                  },
                },
                {
                  key: "facturas",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.FACTURAS) &&
                    !pathname?.includes(ROUTES.FACTURAS_RECURRENTES) &&
                    !pathname?.includes(ROUTES.FACTURAS_PROFORMA)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "tw-pl-2 tw-h-6 tw-align-middle" : ""
                      }`}
                    >
                      {t("nav.invoicesLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.FACTURAS) &&
                          !pathname?.includes(ROUTES.FACTURAS_RECURRENTES) &&
                          !pathname?.includes(ROUTES.FACTURAS_PROFORMA)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "file-invoice",
                    pathname?.includes(ROUTES.FACTURAS) &&
                      !pathname?.includes(ROUTES.FACTURAS_RECURRENTES) &&
                      !pathname?.includes(ROUTES.FACTURAS_PROFORMA)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.FACTURAS)
                  },
                },
                {
                  key: "facturasProforma",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.FACTURAS_PROFORMA)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-start ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "tw-pl-2 tw-h-fit" : ""
                      } tw-my-auto`}
                    >
                      {t("nav.proformaInvoiceLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.FACTURAS_PROFORMA)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "file-dashed-line",
                    pathname?.includes(ROUTES.FACTURAS_PROFORMA)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.FACTURAS_PROFORMA)
                  },
                },
                {
                  key: "facturasRecurrentes",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.FACTURAS_RECURRENTES)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "tw-pl-2 tw-h-6 tw-align-middle" : ""
                      }`}
                    >
                      {t("nav.invocesRecLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.FACTURAS_RECURRENTES)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "clock-rotate-left",
                    pathname?.includes(ROUTES.FACTURAS_RECURRENTES)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.FACTURAS_RECURRENTES)
                  },
                },
                {
                  key: "tickets",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.TICKETS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-start ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-mb-6 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "tw-pl-2 tw-h-fit" : ""
                      } tw-my-auto`}
                    >
                      {t("nav.ticketsLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.TICKETS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "receipt",
                    pathname?.includes(ROUTES.TICKETS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.TICKETS)
                  },
                },
              ],
              variantsSubMenu: {
                initial: {
                  translateY: -80,
                  translateX: -100,
                  scale: 0.2,
                  borderRadius: "99px",
                },
                animate: {
                  translateY: 0,
                  translateX: 0,
                  scale: 1,
                  borderRadius: "8px",
                },
                exit: {
                  translateY: -80,
                  translateX: -100,
                  scale: 0,
                  borderRadius: "99px",
                },
              },
            },
            action: () =>
              setOpenSubMenu({
                documents: !openSubMenu.documents,
                accounting: false,
                inventory: false,
                treasury: false,
                import: false,
              }),
          },
          {
            key: "accounting",
            title: (
              <div className={titleClassName}>{t("nav.accountingLabel")}</div>
            ),
            className: `${sectionItemClassName} ${
              pathname?.includes(ROUTES.CONTABILIDAD)
                ? "tw-text-secondary"
                : "tw-text-white"
            }`,
            classNameSubMenu: submenuClassName,
            leftIcon: (
              <FontAwesomeIcon
                className={titleLeftIconClassName}
                icon={["fal", "calculator"]}
              />
            ),
            rightIcon: (
              <FontAwesomeIcon
                className={titleRightIconClassName}
                icon={[
                  "fal",
                  `${openSubMenu.accounting ? "angle-down" : "angle-right"}`,
                ]}
              />
            ),
            open: openSubMenu.accounting,
            subMenu: {
              title: (
                <div
                  className={`${submenuTitleClassName} ${
                    openSubMenu.accounting ? "tw-max-h-32" : ""
                  }`}
                >
                  <div
                    className={`tw-hidden sm:!tw-flex sm:tw-flex-row tw-justify-start tw-text-lg tw-font-semibold  ${
                      !expandedWidth &&
                      "sm:!tw-block tw-pt-6 tw-pb-4 sm:tw-px-4 sm:tw-rounded"
                    }`}
                  >
                    {submenuSvg}
                    <span className='tw-px-3 tw-align-middle tw-text-lg tw-font-bold tw-h-[24px] tw-my-0.5'>
                      {t("nav.accountingLabel")}
                    </span>
                  </div>
                </div>
              ),
              subMenuClassNameClosed: `${submenuClosedClassName}`,
              subMenuClassNameOpen: "tw-max-h-32 tw-transform",
              items: [
                {
                  key: "cuadrocuentas",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.CONTABILIDAD_CUENTAS_CONTABLES)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 tw-mt-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20 "
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.tableAccountsLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(
                          ROUTES.CONTABILIDAD_CUENTAS_CONTABLES
                        )
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "table",
                    pathname?.includes(ROUTES.CONTABILIDAD_CUENTAS_CONTABLES)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.CONTABILIDAD_CUENTAS_CONTABLES)
                  },
                },
                {
                  key: "librodiario",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.CONTABILIDAD_LIBRO)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.libroJournal")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.CONTABILIDAD_LIBRO)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "notebook",
                    pathname?.includes(ROUTES.CONTABILIDAD_LIBRO)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.CONTABILIDAD_LIBRO)
                  },
                },
                {
                  key: "resumenimpuestos",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.RESUMEN_IMPUESTOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.taxSummaryLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.RESUMEN_IMPUESTOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "magnifying-glass-chart",
                    pathname?.includes(ROUTES.RESUMEN_IMPUESTOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.RESUMEN_IMPUESTOS)
                  },
                },
                {
                  key: "balancesituacion",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.CONTABILIDAD_BALANCE)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  }  tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 tw-items-center hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit tw-items-start hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.balanceLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.CONTABILIDAD_BALANCE)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "scale-balanced",
                    pathname?.includes(ROUTES.CONTABILIDAD_BALANCE)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.CONTABILIDAD_BALANCE)
                  },
                },
                {
                  key: "perdidasyganancias",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.CONTABILIDAD_PERDIDAS_GANANCIAS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 tw-items-center hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit tw-items-start hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.profitLossLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(
                          ROUTES.CONTABILIDAD_PERDIDAS_GANANCIAS
                        )
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "chart-mixed",
                    pathname?.includes(ROUTES.CONTABILIDAD_PERDIDAS_GANANCIAS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.CONTABILIDAD_PERDIDAS_GANANCIAS)
                  },
                },
                {
                  key: "sumaysaldos",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.CONTABILIDAD_SUMAS_SALDOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.additionsBalancesLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.CONTABILIDAD_SUMAS_SALDOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "file-plus-minus",
                    pathname?.includes(ROUTES.CONTABILIDAD_SUMAS_SALDOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.CONTABILIDAD_SUMAS_SALDOS)
                  },
                },
                {
                  key: "prestamos",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.PRESTAMOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.loansLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.PRESTAMOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "percent",
                    pathname?.includes(ROUTES.PRESTAMOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.PRESTAMOS)
                  },
                },
                {
                  key: "activos",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.ACTIVOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-mb-6 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.assetsLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.ACTIVOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "coins",
                    pathname?.includes(ROUTES.ACTIVOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.ACTIVOS)
                  },
                },
              ],
            },
            action: () =>
              setOpenSubMenu({
                documents: false,
                accounting: !openSubMenu.accounting,
                inventory: false,
                treasury: false,
                import: false,
              }),
          },
          {
            key: "treasury",
            title: (
              <div className={titleClassName}>{t("nav.treasuryLabel")}</div>
            ),
            className: `${sectionItemClassName} ${
              pathname?.includes(ROUTES.TESORERIA)
                ? "tw-text-secondary"
                : "tw-text-white"
            }`,
            classNameSubMenu: submenuClassName,
            leftIcon: (
              <FontAwesomeIcon
                className={titleLeftIconClassName}
                icon={["fal", "landmark"]}
              />
            ),
            rightIcon: (
              <FontAwesomeIcon
                className={titleRightIconClassName}
                icon={[
                  "fal",
                  `${openSubMenu.treasury ? "angle-down" : "angle-right"}`,
                ]}
              />
            ),
            open: openSubMenu.treasury,
            subMenu: {
              title: (
                <div
                  className={`${submenuTitleClassName} ${
                    openSubMenu.treasury ? "tw-max-h-32" : ""
                  } `}
                >
                  <div
                    className={`tw-hidden sm:!tw-flex sm:tw-flex-row tw-justify-start tw-text-lg tw-font-semibold  ${
                      !expandedWidth &&
                      "sm:!tw-block tw-pt-6 tw-pb-4 sm:tw-px-4 sm:tw-rounded"
                    }`}
                  >
                    {submenuSvg}
                    <span className='tw-px-3 tw-align-middle tw-text-lg tw-font-bold tw-h-[24px] tw-my-0.5'>
                      {t("nav.treasuryLabel")}
                    </span>
                  </div>
                </div>
              ),
              subMenuClassNameClosed: `${submenuClosedClassName}`,
              subMenuClassNameOpen: `tw-max-h-32 tw-transform`,
              items: [
                {
                  key: "cuentasbancarias",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.BANCOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 tw-mt-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.accountBancLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.BANCOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "building-columns",
                    pathname?.includes(ROUTES.BANCOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.BANCOS)
                  },
                },
                {
                  key: "pagoscobros",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.PAGOS_COBROS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.paymentsCollectionsLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.PAGOS_COBROS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "money-bill-transfer",
                    pathname?.includes(ROUTES.PAGOS_COBROS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.PAGOS_COBROS)
                  },
                },
                {
                  key: "cartera",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.CARTERA)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.portfolioLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.CARTERA)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "wallet",
                    pathname?.includes(ROUTES.CARTERA)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.CARTERA)
                  },
                },
                {
                  key: "remesas",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.REMESAS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.remittanceLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.REMESAS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "arrow-down-arrow-up",
                    pathname?.includes(ROUTES.REMESAS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.REMESAS)
                  },
                },
                {
                  key: "devolucioningresos",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.DEVOLUCIONES_INGRESOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.repaymentLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.DEVOLUCIONES_INGRESOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "turn-down-left",
                    pathname?.includes(ROUTES.DEVOLUCIONES_INGRESOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.DEVOLUCIONES_INGRESOS)
                  },
                },
                {
                  key: "reembolsoTickets",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.REEMBOLSO_TICKETS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-mb-6 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.ticketsRefund")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.REEMBOLSO_TICKETS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "receipt",
                    pathname?.includes(ROUTES.REEMBOLSO_TICKETS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.REEMBOLSO_TICKETS)
                  },
                },
              ],
            },
            action: () =>
              setOpenSubMenu({
                documents: false,
                accounting: false,
                inventory: false,
                treasury: !openSubMenu.treasury,
                import: false,
              }),
          },
          {
            key: "contact",
            title: (
              <div className={titleClassName}>{t("nav.contactLabel")}</div>
            ),
            className: `${sectionItemClassName} ${
              pathname?.includes(ROUTES.CONTACTOS)
                ? "tw-text-secondary"
                : "tw-text-white"
            }`,
            classNameSubMenu: submenuClassName,
            leftIcon: (
              <FontAwesomeIcon
                className={titleLeftIconClassName}
                icon={["fal", "briefcase"]}
              />
            ),
            action: () => {
              action(ROUTES.CONTACTOS, {}, true)
            },
          },
          {
            key: "inventario",
            title: (
              <div className={titleClassName}>{t("nav.inventoryLabel")}</div>
            ),
            className: `${sectionItemClassName} ${
              pathname?.includes(ROUTES.INVENTARIO)
                ? "tw-text-secondary"
                : "tw-text-white"
            }`,
            classNameSubMenu: submenuClassName,
            leftIcon: (
              <FontAwesomeIcon
                className={titleLeftIconClassName}
                icon={["fal", "clipboard"]}
              />
            ),
            rightIcon: (
              <FontAwesomeIcon
                className={titleRightIconClassName}
                icon={[
                  "fal",
                  `${openSubMenu.inventory ? "angle-down" : "angle-right"}`,
                ]}
              />
            ),
            open: openSubMenu.inventory,
            subMenu: {
              title: (
                <div
                  className={`${submenuTitleClassName} ${
                    openSubMenu.inventory ? "tw-max-h-32" : ""
                  }`}
                >
                  <div
                    className={`tw-hidden sm:!tw-flex sm:tw-flex-row tw-justify-start tw-text-lg tw-font-semibold  ${
                      !expandedWidth &&
                      "sm:!tw-block tw-pt-6 tw-pb-4 sm:tw-px-4 sm:tw-rounded"
                    }`}
                  >
                    {submenuSvg}
                    <span className='tw-px-3 tw-align-middle tw-text-base tw-font-bold tw-h-[24px] tw-my-0.5'>
                      {t("nav.inventoryLabel")}
                    </span>
                  </div>
                </div>
              ),
              subMenuClassNameClosed: `${submenuClosedClassName}`,
              subMenuClassNameOpen: "tw-max-h-32 !tw-max-w-xl",
              items: [
                {
                  key: "articulos",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.ARTICULOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 tw-mt-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit  hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.articlesLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.ARTICULOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "cart-shopping",
                    pathname?.includes(ROUTES.ARTICULOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.ARTICULOS)
                  },
                },
                {
                  key: "catalogo",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.CATALOGOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit  hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.catalogLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.CATALOGOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "book-open-cover",
                    pathname?.includes(ROUTES.CATALOGOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.CATALOGOS)
                  },
                },
                {
                  key: "categorias",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.CATEGORIAS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-mb-6 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.categoryLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.CATEGORIAS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "folder-tree",
                    pathname?.includes(ROUTES.CATEGORIAS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.CATEGORIAS)
                  },
                },
              ],
            },
            action: () =>
              setOpenSubMenu({
                documents: false,
                accounting: false,
                inventory: !openSubMenu.inventory,
                treasury: false,
                import: false,
              }),
          },
          {
            key: "importar",
            title: (
              <div className={titleClassName}> {t("nav.importLabel")}</div>
            ),
            className: `${sectionItemClassName} ${
              pathname?.includes(ROUTES.IMPORTAR)
                ? "tw-text-secondary"
                : "tw-text-white"
            }`,
            classNameSubMenu: `${submenuClassName} ${
              !expandedWidth ? "md:!tw--mt-60" : ""
            }`,
            leftIcon: (
              <FontAwesomeIcon
                className={titleLeftIconClassName}
                icon={["fal", "file-import"]}
              />
            ),
            rightIcon: (
              <FontAwesomeIcon
                className={titleRightIconClassName}
                icon={[
                  "fal",
                  `${openSubMenu.import ? "angle-down" : "angle-right"}`,
                ]}
              />
            ),
            open: openSubMenu.import,
            subMenu: {
              title: (
                <div
                  className={`${submenuTitleClassName} ${
                    openSubMenu.import ? "tw-max-h-32" : ""
                  }`}
                >
                  <div
                    className={`tw-hidden sm:!tw-flex sm:tw-flex-row tw-justify-start tw-text-lg tw-font-semibold  ${
                      !expandedWidth &&
                      "sm:!tw-block tw-pt-6 tw-pb-4 sm:tw-px-4 sm:tw-rounded"
                    }`}
                  >
                    {submenuSvg}
                    <span className='tw-px-3 tw-align-middle tw-text-base tw-font-bold tw-h-[24px] tw-my-0.5'>
                      {t("nav.importLabel")}
                    </span>
                  </div>
                </div>
              ),
              subMenuClassNameClosed: `${submenuClosedClassName} `,
              subMenuClassNameOpen: "tw-max-h-32 !tw-max-w-xl",
              items: [
                {
                  key: "importFacturas",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.IMPORTAR_FACTURAS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 tw-mt-1 ${
                    expandedWidth
                      ? "tw-h-10  hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit tw-mx-1 hover:!tw-bg-background"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.invoicesLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.IMPORTAR_FACTURAS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "file-invoice",
                    pathname?.includes(ROUTES.IMPORTAR_FACTURAS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    modals.openModalImport()
                  },
                },
                {
                  key: "importProductos",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.IMPORTAR_PRODUCTOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.productLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.IMPORTAR_PRODUCTOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "box",
                    pathname?.includes(ROUTES.IMPORTAR_PRODUCTOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.IMPORTAR_PRODUCTOS)
                  },
                },
                {
                  key: "importContactos",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.IMPORTAR_CONTACTOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10 hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.contactLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.IMPORTAR_CONTACTOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "briefcase",
                    pathname?.includes(ROUTES.IMPORTAR_CONTACTOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.IMPORTAR_CONTACTOS)
                  },
                },
                {
                  key: "importActivoFijo",
                  className: `tw-flex tw-rounded tw-bg-white ${
                    pathname?.includes(ROUTES.IMPORTAR_ACTIVOS)
                      ? !expandedWidth
                        ? "tw-bg-background tw-mx-1 !tw-pl-3"
                        : "tw-bg-opacity-20"
                      : "tw-bg-opacity-0"
                  } tw-items-center tw-mb-1 ${
                    expandedWidth
                      ? "tw-h-10  hover:!tw-bg-opacity-20"
                      : "tw-pl-4 tw-py-2 tw-mb-6 tw-h-fit hover:!tw-bg-background tw-mx-1"
                  }`,
                  title: (
                    <span
                      className={`tw-flex tw-flex-row tw-items-center tw-text-base tw-font-normal tw-text-left ${
                        !expandedWidth ? "lg:tw-pl-2" : ""
                      }`}
                    >
                      {t("nav.activosLabel")}
                      {rightIconNotification(
                        expandedWidth,
                        pathname?.includes(ROUTES.IMPORTAR_ACTIVOS)
                      )}
                    </span>
                  ),
                  rightIcon: <></>,
                  leftIcon: leftIconNotification(
                    expandedWidth,
                    "coins",
                    pathname?.includes(ROUTES.IMPORTAR_ACTIVOS)
                  ),
                  subMenu: "",
                  action: () => {
                    !expandedWidth && closeAllMenus()
                    action(ROUTES.IMPORTAR_ACTIVOS)
                  },
                },
              ],
            },
            action: () =>
              setOpenSubMenu({
                documents: false,
                accounting: false,
                inventory: false,
                treasury: false,
                import: !openSubMenu.import,
              }),
          },
          {
            key: "ocr",
            title: <div className={titleClassName}> {t("nav.ocrLabel")}</div>,
            className: `${sectionItemClassName} ${
              pathname?.includes(ROUTES.IMPORTAR_FACTURAS_OCR)
                ? "tw-text-secondary"
                : "tw-text-white"
            }`,
            leftIcon: (
              <FontAwesomeIcon
                className={titleLeftIconClassName}
                icon={["fal", "file-pdf"]}
              />
            ),
            action: () => {
              action(ROUTES.IMPORTAR_FACTURAS_OCR, {}, true)
            },
          },
        ],
      },
    },
    {
      section: {
        key: "withSectionTitleOps",
        title: (
          <div className='tw-text-left tw-text-secondary'>
            {t("nav.aplication")}
          </div>
        ),
        className: `${sectionClassName} tw-mt-8 lg:tw-hidden tw-uppercase`,
        items: [
          {
            key: "ops",
            title: <div className={titleClassName}>{t("nav.opsLabel")}</div>,
            className: `${sectionItemClassName} tw-text-white ${
              expandedWidth ? "xl:tw-flex-row xl:tw-uppercase" : ""
            }`,
            leftIcon: (
              <svg
                width='20'
                height='20'
                viewBox='0 0 40 40'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className={titleLeftIconClassName}
              >
                <path
                  d='M8 0H36L27.8182 8H0L8 0Z'
                  fill='#00B993'
                />
                <path
                  d='M33 40H5L12.9546 32H40L33 40Z'
                  fill='#00B993'
                />
                <path
                  d='M8 0V32L0 40L9.4554e-06 8L8 0Z'
                  fill='#00B993'
                />
                <path
                  d='M33 40V7.99999L40 0V32L33 40Z'
                  fill='#00B993'
                />
                <path
                  d='M8 8V0L0 8H8Z'
                  fill='#00B993'
                />
                <path
                  d='M33 32V40L40 32H33Z'
                  fill='#00B993'
                />
                <path
                  d='M25 24V16H16V24H25Z'
                  fill='white'
                />
              </svg>
            ),
            action: () => {
              modals.setCollapsed(false)
              modals.handleRedirect(KEYS.GEFINTECH)
            },
          },
        ],
      },
    },
    {
      section: {
        key: "withSectionTitle",
        title: "",
        className: `${sectionClassName} tw-mt-8 lg:tw-hidden tw-mb-6`,
        items: [
          {
            key: "compartirHerramienta",
            title: (
              <div className='tw-flex tw-w-full tw-h-12 tw-rounded-md tw-bg-white tw-text-primary tw-justify-center tw-items-center'>
                {t("nav.compartirHer")}
              </div>
            ),
            className: ``,
            action: () => {
              modals.setInvitation(true)
            },
          },
        ],
      },
    },
  ]
}

interface mobileMenuListProps {
  action: (path: string) => void
  t: TFunction
}

export const MOBILE_MENU_LIST = ({ action, t }: mobileMenuListProps) => [
  {
    id: "accesoRapido",
    section: t("nav.shortCutLabel"),
    items: [
      {
        id: "factura",
        name: t("nav.invoicesLabel"),
        icon: (
          <FontAwesomeIcon
            className='tw-h-8 tw-mb-4 tw-text-primary'
            icon={["fal", "file-invoice"]}
          />
        ),
        action: () => action(ROUTES.FACTURAS),
      },
      {
        id: "ticket",
        name: t("nav.ticketsLabel"),
        icon: (
          <FontAwesomeIcon
            className='tw-h-8 tw-mb-4 tw-text-primary'
            icon={["fal", "receipt"]}
          />
        ),
        action: () => action(ROUTES.TICKETS),
      },
      {
        id: "tarjetas",
        name: t("nav.cardsLabel"),
        icon: (
          <FontAwesomeIcon
            className='tw-h-8 tw-mb-4 tw-text-primary'
            icon={["fal", "credit-card"]}
          />
        ),
        action: () => action(ROUTES.TARJETAS),
      },
      {
        id: "contactos",
        name: t("nav.contactLabel"),
        icon: (
          <FontAwesomeIcon
            className='tw-h-8 tw-mb-4 tw-text-primary'
            icon={["fal", "users"]}
          />
        ),
        action: () => action(ROUTES.CONTACTOS),
      },
      {
        id: "articulos",
        name: t("nav.articlesLabel"),
        icon: (
          <FontAwesomeIcon
            className='tw-h-8 tw-mb-4 tw-text-primary'
            icon={["fal", "cart-shopping"]}
          />
        ),
        action: () => action(ROUTES.ARTICULOS),
      },
    ],
  },
  {
    id: "documentos",
    section: t("nav.documentLabel"),
    items: [
      {
        id: "albaranes",
        name: t("nav.deliveryLabel"),
        icon: (
          <FontAwesomeIcon
            className='tw-h-8 tw-mb-4 tw-text-primary'
            icon={["fal", "file-contract"]}
          />
        ),
        action: () => action(ROUTES.ALBARANES),
      },
      {
        id: "pedidos",
        name: t("nav.orderLabel"),
        icon: (
          <FontAwesomeIcon
            className='tw-h-8 tw-mb-4 tw-text-primary'
            icon={["fal", "file-lines"]}
          />
        ),
        action: () => action(ROUTES.PEDIDOS),
      },
      {
        id: "presupuesto",
        name: t("nav.quotationLabel"),
        icon: (
          <FontAwesomeIcon
            className='tw-h-8 tw-mb-4 tw-text-primary'
            icon={["fal", "file"]}
          />
        ),
        action: () => action(ROUTES.PRESUPUESTOS),
      },
    ],
  },
  {
    id: "contabilidad",
    section: t("nav.accountingLabel"),
    items: [
      {
        id: "impuestos",
        name: t("nav.taxSummaryLabel"),
        icon: (
          <FontAwesomeIcon
            className='tw-h-8 tw-mb-4 tw-text-primary'
            icon={["fal", "calculator"]}
          />
        ),
        action: () => action(ROUTES.RESUMEN_IMPUESTOS),
      },
      {
        id: "balance",
        name: t("nav.balanceLabel"),
        icon: (
          <FontAwesomeIcon
            className='tw-h-8 tw-mb-4 tw-text-primary'
            icon={["fal", "scale-balanced"]}
          />
        ),
        action: () => action(ROUTES.CONTABILIDAD_BALANCE),
      },
      {
        id: "perdidas",
        name: t("nav.profitLossLabel"),
        icon: (
          <FontAwesomeIcon
            className='tw-h-8 tw-mb-4 tw-text-primary'
            icon={["fal", "chart-mixed"]}
          />
        ),
        action: () => action(ROUTES.CONTABILIDAD_PERDIDAS_GANANCIAS),
      },
    ],
  },
]
